<template>
<div style="min-height:200px;">
  <el-row type="flex" justify="end">
    <w-header-search-button @click="onClickSetSearchToolVisible"></w-header-search-button>
  </el-row>
  <el-table-wrapper border :data="tableData" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" ref="table" style="width:100%;">
    <template slot-scope="scope" slot="loghist-slot">
      <i class="el-icon-search"></i>
    </template>
  </el-table-wrapper>
</div>
</template>
<script>
import moment from 'moment';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import isNil from 'lodash/isNil';

const severityFilters = [{ text: 'Error', value: 'Error' }, { text: 'Warning', value: 'Warning' }, { text: 'Informational', value: 'Informational' }];
export default {
  name: 'WSyslogTable',
  props: {
    tableData: {
      type: Array,
    },
  },
  data() {
    return {
      columns: [{
        prop: 'objName',
        label: '장비명',
        showOverflowTooltip: true,
        sortable: true,
        width: 120,
        headerAlign: 'center',
        formatter: this.getTableValueAfterCheckEmpty,
      }, {
        prop: 'ipaddress',
        label: 'IP 주소',
        showOverflowTooltip: true,
        sortable: true,
        width: 120,
        headerAlign: 'center',
        formatter: this.getTableValueAfterCheckEmpty,
      }, {
        prop: 'syslogPriorityName',
        label: 'severity',
        filters: severityFilters,
        filterMultiple: false,
        showOverflowTooltip: true,
        sortable: true,
        width: 120,
        headerAlign: 'center',
        filterMethod: this.filterSyslogPriorityName,
      }, {
        prop: 'syslogMessage',
        label: '메시지',
        sortable: true,
        showOverflowTooltip: true,
        searchable: true,
        headerAlign: 'center',
        formatter: this.getTableValueAfterCheckEmpty,
      }, {
        prop: 'eventDatetime',
        label: '수집시각',
        sortable: true,
        showOverflowTooltip: true,
        searchable: true,
        searchType: 'date',
        formatter: this.getDateFormatter,
        width: 160,
      }],
      showSearchTool: false,
    };
  },
  methods: {
    /**
     * [검색기능 show]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    onClickSetSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    /**
     * [날짜 포멧 설정]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getDateFormatter(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : moment(new Date(value)).format('YYYY-MM-DD HH:mm:ss');
    },
    filterSyslogPriorityName(value, row) {
      return row.syslogPriorityName === value;
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/netinterface/components/SyslogTable.vue